/* eslint no-lone-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint no-unused-vars: 0 */
/* eslint array-callback-return: 0 */
/* eslint jsx-a11y/anchor-is-valid: 0 */
import React, {Component} from 'react';
import './App.css';
import {BidList} from './BidList'

import Tab from  'semantic-ui-react/dist/es/modules/Tab';

export class Bids extends Component {
    constructor(props) {
        super(props);
        this.state = {
            access_token: this.props.access_token,
            isLoggedIn: this.props.isLoggedIn,
            randombpid: Math.random(),
            randomdpid: Math.random(),
            current_user: JSON.parse(sessionStorage.getItem("current_user"))


        };


    }

    

    render() {
        const {isLoggedIn, access_token, current_user} = this.state
        var panes = []
        panes.push({
                        menuItem: 'Bids',
                        pane: (<Tab.Pane key="7"> <BidList isLoggedIn={isLoggedIn} access_token={access_token}
                                                        reloadThis={this.reload} current_user={current_user} /></Tab.Pane>)
        })
        return (
        
                    <div>
                        <Tab renderActiveOnly={false} panes={panes}/>
        
                    </div>
        
        
                );
    }
}